import { render, staticRenderFns } from "./copiarTarjas.vue?vue&type=template&id=4c67443e&"
import script from "./copiarTarjas.vue?vue&type=script&lang=js&"
export * from "./copiarTarjas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports